<template>
  <div class="max-height">
    <div v-if="!cargado" class="text-center m-t">
      {{ $I18n.t('cargando') }}...
    </div>
    <transition enter-active-class="animated fadeInDown">
      <cuaderno-layout v-if="cargado" :info-cuaderno="infoCuaderno" :info-alumnos="infoAlumnos">
        <template #header>
          <cabecera-fecha-sesiones
            :fecha="fechaCuaderno"
            :fechas-validas="fechasValidas"
            :horarios="infoCuaderno.horarios"
            :horario-actual-id="horarioActualId"
            :evaluacion="infoCuaderno.evaluacion"
            :preferencias-view="preferenciasView"
            :info-cuaderno="infoCuaderno"
            @cambio-fecha="cambiafechaCuaderno($event)"
            @cambio-horario="gotoHorario($event)"
            @recargar-cuaderno="recargarCuaderno"
          />
        </template>
        <template #row-headers>
          <div v-for="tipo in tiposAsistencia" :key="tipo" class="cc-col-icon">
            {{ humanEnumName('alumno_asistencia', 'tipo', tipo) }}
          </div>
          <div
            v-if="tieneTurnos"
            class="cc-col-input cc-col-aplicar-a"
          >
            {{ $I18n.t('aplicar_a') }}
          </div>
          <div class="cc-col-icon">
            {{ $I18n.t('notificar') }}
          </div>
          <div class="cc-col-input">
            {{ $I18n.t('observaciones') }}
          </div>
          <div class="cc-col-icon"></div>
        </template>
        <template #rows>
          <fila-asistencia
            v-for="info in infoAlumnos"
            :key="info.alumno.id"
            ref="filasAsistencias"
            :admin="admin"
            :info-cuaderno="infoCuaderno"
            :tipos-asistencia="tiposAsistencia"
            :turnos-validos="infoCuaderno.turnos_validos"
            :alumno-asistencia="info.asistencia"
            class="cc-row row-asistencia"
          />
        </template>
        <template #bottom>
          <div
            v-if="registroAsistencia"
            class="text-success pull-left m-t-sm"
            data-toggle="tooltip"
            :title="tooltipRegistroAsistencia"
          >
            <i class="far fa-check-circle"></i> {{ $I18n.t('registrado') }}
          </div>
          <button class="btn btn-cifra btn-guardar" @click="guardar">
            {{ $I18n.t('Guardar') }}
          </button>
        </template>
      </cuaderno-layout>
    </transition>
  </div>
</template>

<script>
import { usuarios } from 'cifra-api-js';
import toast from '../../../libs/cifra/toast';
import CuadernoLayout from './CuadernoLayout.vue';
import CabeceraFechaSesiones from './CabeceraFechaSesiones.vue';
import PreferenciasView from './asistencias/PreferenciasView.vue';
import FilaAsistencia from './FilaAsistencia.vue';
import { showApiErrors } from '../../../libs/cifra/flash';
import humanEnumName from '../../../libs/i18n';
import { dateToDateTimeString } from '../../../libs/dates';
import Overlay from '../../../libs/cifra/overlay';
import cuadernoAsistencias from '../../../api/cifra/cuadernos/asistencias';

export default {
  components: { CuadernoLayout, CabeceraFechaSesiones, FilaAsistencia },
  props: {
    admin: { type: Boolean, default: false },
    cuadernoId: { type: Number, required: true },
    fecha: { type: String, required: true },
    fechasValidas: { type: Array, required: true },
    horarioId: { type: Number, required: true },
    guardiaId: { type: Number, required: false, default: null },
    tiposAsistencia: { type: Array, required: true },
  },
  data() {
    return {
      infoCuaderno: {},
      infoAlumnos: {},
      fechaCuaderno: this.fecha,
      horarioActualId: this.horarioId,
      cargado: false,
    };
  },
  computed: {
    tieneTurnos() {
      return this.infoCuaderno.turnos_validos.length > 0;
    },
    registroAsistencia() {
      return this.infoCuaderno.registro_asistencia;
    },
    tooltipRegistroAsistencia() {
      return this.$I18n.t(
        'registrado_usuario_fecha',
        {
          usuario: usuarios.fullname(this.registroAsistencia.usuario, false),
          fecha: dateToDateTimeString(this.registroAsistencia.created_at),
        },
      );
    },
    puedePreferencias() {
      return !!this.infoCuaderno.preferencias?.cuaderno_profesor_id;
    },
    preferenciasView() {
      return this.puedePreferencias ? PreferenciasView : null;
    },
  },
  mounted() {
    this._goToCuaderno(this.cuadernoId, this.fechaCuaderno, this.horarioId, this.guardiaId);
  },
  methods: {
    humanEnumName,
    guardar() {
      const overlay = this._setOverlay();
      cuadernoAsistencias.pasarLista(this.toJson(), this.admin).then(() => {
        this._goToCuaderno(
          this.infoCuaderno.id,
          this.infoCuaderno.fecha,
          this.infoCuaderno.horario.id,
          this.infoCuaderno.guardia?.id,
        );
        toast.success(this.$I18n.t('guardado_correcto'));
      }).catch((result) => {
        overlay.hide();
        showApiErrors(result);
      });
    },
    toJson() {
      const data = {
        cuaderno_id: this.infoCuaderno.id,
        evaluacion_id: this.infoCuaderno.evaluacion.id,
        fecha: this.infoCuaderno.fecha,
        horario_id: this.infoCuaderno.horario.id,
        alumno_asistencias: [],
      };
      this.$refs.filasAsistencias.forEach((fila) => {
        if (fila.editado) {
          data.alumno_asistencias.push(fila.toJson());
        }
      });
      return data;
    },
    gotoHorario(horario) {
      if (horario.actual) {
        return;
      }
      this._goToCuaderno(this.infoCuaderno.id, this.fechaCuaderno, horario.id);
    },
    cambiafechaCuaderno(value) {
      // Siempre tiene que haber fecha
      if (!value) {
        this.fechaCuaderno = this.infoCuaderno.fecha;
        return;
      }
      // Si cambia la fecha no enviamos el horario porque el id del lunes no es el mismo
      // que los de los jueves etc.
      this._goToCuaderno(this.infoCuaderno.id, value);
    },
    recargarCuaderno() {
      this._goToCuaderno(this.infoCuaderno.id, this.fechaCuaderno);
    },
    _goToCuaderno(idCuaderno, fecha, horarioId, guardiaId = null) {
      const overlay = this._setOverlay();
      cuadernoAsistencias.infoCuaderno(
        idCuaderno,
        fecha,
        horarioId,
        this.admin,
        { params: { guardia_id: guardiaId } },
      ).then((result) => {
        overlay.hide();
        const { data } = result;
        this.infoCuaderno = data.info_cuaderno;
        this.infoAlumnos = data.info_alumnos;
        // Puede que la fecha no sea la que le enviamos porque no sea válida
        this.fechaCuaderno = this.infoCuaderno.fecha;
        this.horarioActualId = this.infoCuaderno.horario.id;
        // Hacemos esto para que repinte con la animación
        this.cargado = false;
        this.$nextTick(() => { this.cargado = true; });
      }).catch((result) => {
        this.cargado = true;
        overlay.hide();
        showApiErrors(result);
        // Si hubo error dejamos la fecha original
        this.fechaCuaderno = this.infoCuaderno.fecha;
      });
    },
    _setOverlay() {
      const overlay = new Overlay(this.$el);
      overlay.show();
      return overlay;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/components/cuadernos/constantes_cuaderno.scss';

  .cc-col-aplicar-a {
    width: 120px;
    max-width: 120px;
  }
  :deep(.cc-headers) {
    border-bottom: 4px solid $border-color;
  }
  .cc-middle .cc-headers {
    .cc-col-icon, .cc-col-input {
      border-bottom: 4px solid $border-color;
    }
  }
  .cc-row {
    background-color: white !important;
  }
</style>
